import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/solid";
import ClassNames from "classnames";
type SessionsPaginationProps = {
  nextButtonLabel: string;
  prevButtonLabel: string;
  onClickNext: () => void;
  onClickPrev: () => void;
  disabledNext?: boolean;
  disabledPrev?: boolean;
};
export default function SessionsPagination(props: SessionsPaginationProps) {
  const {
    nextButtonLabel,
    prevButtonLabel,
    onClickNext,
    onClickPrev,
    disabledPrev,
    disabledNext,
  } = props;
  return (
    <div className="bg-gray-900">
      <div className="relative">
        <nav
          className="bg-gray-50 first-letter: flex flex-col xl:hidden  w-full py-3 border-gray-200 fixed bottom-0 md:left-0 md:right-0 lg:ltr:left-64 lg:rtl:right-64 lg:ltr:w-[calc(100%_-_16rem)] lg:rtl:w-[calc(100%_-_16rem)]"
          aria-label="Pagination"
          dir="rtl"
        >
          <div className="w-full flex justify-between px-4">
            <button
              data-cy="nextSession"
              onClick={onClickNext}
              disabled={disabledNext}
              className={ClassNames(
                "inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50",
                { "opacity-50 cursor-not-allowed": disabledNext }
              )}
            >
              <ArrowLeftIcon className="w-5 h-5 rtl:rotate-180  mx-1" />
              {nextButtonLabel}
            </button>
            <button
              data-cy="prevSession"
              onClick={onClickPrev}
              disabled={disabledPrev}
              className={ClassNames(
                "inline-flex items-center px-4 py-2  text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50",
                { "opacity-50 cursor-not-allowed": disabledPrev }
              )}
            >
              {prevButtonLabel}
              <ArrowRightIcon className="w-5 h-5 rtl:rotate-180  mx-1" />
            </button>
          </div>
        </nav>
      </div>
    </div>
  );
}
